import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import * as d3 from 'd3';
import css_248z from './barChart.styles.css.js';

let BarChart = class BarChart extends LitElement {
    constructor() {
        super(...arguments);
        this.data = [];
        this.minY = -40;
        this.maxY = 40;
    }
    firstUpdated() {
        window.addEventListener('resize', this.renderChart.bind(this));
        this.renderChart();
    }
    updated(changedProperties) {
        if (changedProperties.has('data') ||
            changedProperties.has('minY') ||
            changedProperties.has('maxY')) {
            this.renderChart();
        }
    }
    renderChart() {
        var _a;
        if (!this.data.length)
            return;
        const margin = { top: 20, right: 20, bottom: 40, left: 50 };
        const svgElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('svg');
        if (!svgElement)
            return;
        const { width, height } = svgElement.getBoundingClientRect();
        const svg = d3
            .select(svgElement)
            .html('')
            .attr('width', width)
            .attr('height', height);
        const x = d3
            .scaleBand()
            .domain(this.data.map((d) => d.category))
            .range([margin.left, width - margin.right])
            .padding(0.2);
        const y = d3
            .scaleLinear()
            .domain([this.minY, this.maxY])
            .range([height - margin.bottom, margin.top]);
        // Eje X
        const xAxis = svg
            .append('g')
            .attr('transform', `translate(0,${height - margin.bottom})`)
            .attr('class', 'axis')
            .call(d3.axisBottom(x));
        xAxis.select('path').remove();
        xAxis.selectAll('line').remove();
        // Eje Y
        const yAxis = svg
            .append('g')
            .attr('transform', `translate(${margin.left},0)`)
            .attr('class', 'axis')
            .call(d3.axisLeft(y).tickFormat((d) => d.toFixed(2)));
        yAxis.select('path').remove();
        yAxis.selectAll('line').remove();
        // Línea gris en y = 0
        svg
            .append('line')
            .attr('x1', margin.left)
            .attr('x2', width - margin.right)
            .attr('y1', y(0))
            .attr('y2', y(0))
            .attr('stroke', 'var(--line-zero-color)')
            .attr('stroke-width', 2);
        // Fondo por categoría
        svg
            .selectAll('.bar-background')
            .data(this.data)
            .enter()
            .append('rect')
            .attr('x', (d) => x(d.category))
            .attr('y', y(this.maxY))
            .attr('width', x.bandwidth())
            .attr('height', y(this.minY) - y(this.maxY))
            .attr('fill', 'var(--background-color)')
            .lower();
        // Barras
        const colors = [
            'var(--bar-color-1)',
            'var(--bar-color-2)',
            'var(--bar-color-3)',
            'var(--bar-color-2)',
            'var(--bar-color-1)',
            'var(--bar-color-3)',
        ];
        // Barras
        svg
            .selectAll('.bar')
            .data(this.data)
            .enter()
            .append('rect')
            .attr('x', (d) => x(d.category))
            .attr('y', (d) => (d.value >= 0 ? y(d.value) : y(0)))
            .attr('width', x.bandwidth())
            .attr('height', (d) => Math.abs(y(d.value) - y(0)))
            .attr('fill', () => colors.shift());
        // Línea blanca marker
        svg
            .selectAll('.marker')
            .data(this.data)
            .enter()
            .append('line')
            .attr('x1', (d) => x(d.category) + x.bandwidth() / 4)
            .attr('x2', (d) => x(d.category) + (3 * x.bandwidth()) / 4)
            .attr('y1', (d) => y(d.marker))
            .attr('y2', (d) => y(d.marker))
            .attr('stroke', 'var(--marker-color)')
            .attr('stroke-width', 2);
    }
    render() {
        return html `<svg></svg>`;
    }
};
BarChart.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: Array })
], BarChart.prototype, "data", void 0);
__decorate([
    property({ type: Number })
], BarChart.prototype, "minY", void 0);
__decorate([
    property({ type: Number })
], BarChart.prototype, "maxY", void 0);
BarChart = __decorate([
    customElement('ht-bar-chart')
], BarChart);
var BarChart$1 = BarChart;

export { BarChart$1 as default };
//# sourceMappingURL=barChart.js.map
